class ViewerConfig  {
    constructor() {
        this.settings = {
            autoFit: true,
            showGrid: true,
            showOrigin: true,

            showNodes: true,
            showNodeLabels: true,

            showSupports: true,
            supportsScale: 1,
            supportsColor: '#007000',

            showMembers: true,
            showMemberLabels: true,
            showMemberLocalAxis: false,
            showMemberEndFixities: true,

            showForces: true,
            forcesScaleFactor: 1,
            forcesColor: '#2334b0',

            showReactions: true,
            reactionsScaleFactor: 1,
            reactionsColor: '#a118d7',

            showAxialForces: true,
            axialForcesScaleFactor: 1,
            axialForcesColor: '#c48210',

            showShearForces: true,
            shearForcesScaleFactor: 1,
            shearForcesColor: '#007000',

            showBendingMoments: true,
            bendingMomentsScaleFactor: 1,
            bendingMomentsColor: '#ba3733',

            showDeformations: true,
            deformationsScaleFactor: 50,
            deformationsColor: '#00449c',
        };

        this.listeners = {};
    }

    updateSetting(key, value) {
        if (key in this.settings) {
            if (this.settings[key] === value) {
                return;
            }
            this.settings[key] = value;
            this.notifyListeners(key, value);
        } else {
            console.warn(`Setting ${key} does not exist.`);
        }
    }

    updateSettings(updates) {
        for (const key in updates) {
            this.updateSetting(key, updates[key]);
        }
    }

    addListener(key, callback) {
        if (!this.listeners[key]) {
            this.listeners[key] = [];
        }
        this.listeners[key].push(callback);
    }

    notifyListeners(key, value) {
        if (this.listeners[key]) {
            this.listeners[key].forEach(callback => callback(value));
        }
    }
}

export { ViewerConfig };